import { MutationTree } from "vuex";
import { CommonState, ApiError, ApplianceList, AttachmentList, PantryCameraImageResult } from "@/types/common";

const mutations: MutationTree<CommonState> = {
  startLoading: state => {
    state.isLoading = true;
  },
  stopLoading: state => {
    state.isLoading = false;
  },
  updateToken: (state, token: string) => {
    state.apiBaseParams.token = token;
  },
  updateApiKey: (state, apiKey: string) => {
    state.apiBaseParams.apiKey = apiKey;
  },
  updateApplianceId: (state, applianceId: string) => {
    state.apiBaseParams.applianceId = applianceId;
  },
  updateAppliance: (state, appliance: string) => {
    state.apiBaseParams.appliance = appliance;
  },
  updateTermId: (state, termId: string) => {
    state.apiBaseParams.termId = termId;
  },
  updateApiError: (state, apiError: ApiError | null) => {
    state.apiError = apiError;
  },
  updateLogId: (state, logId: string | null) => {
    state.logId = logId;
  },
  updateApplianceList: (state, applianceList: ApplianceList | null) => {
    state.apiBaseParams.applianceList = applianceList;
  },
  updateSearchAppliance: (state, appliance: string | null) => {
    state.searchAppliance = appliance;
  },
  updateUserAgent: (state, userAgent: string | null) => {
    state.apiBaseParams.userAgent = userAgent;
  },
  updateAttachmentList: (state, attachmentList: AttachmentList | null) => {
    state.attachmentList = attachmentList;
  },
  updateFullscreenLoading: (state, newState: boolean) => {
    state.isFullscreenLoading = newState;
  },
  updatePantryCameraImage: (state, newState: PantryCameraImageResult) => {
    state.pantryCameraImage = newState;
  }
};

export default mutations;
